import * as React from 'react';
import { Icon, IconProps } from '../Icon';

export const Success: React.FC<IconProps> = (props) => (
  <Icon viewBox="0 0 14 14" {...props}>
    <path d="M7 0a7 7 0 110 14A7 7 0 017 0zm3.6 3.03a.875.875 0 00-1.23.149l-.115.15c-.675.91-1.78 2.75-2.74 4.5l-.446.818-.07-.111c-.613-.94-1.34-1.82-1.8-1.96a.875.875 0 00-.72 1.58l.077.041.131.137.055.064c.164.194.365.467.579.784.412.61.815 1.31.974 1.67a.875.875 0 001.59.04c1.03-2.07 3.01-5.53 3.87-6.63a.875.875 0 00-.15-1.23z" />
  </Icon>
);
